import { render, staticRenderFns } from "./RecebimentoAdesao.vue?vue&type=template&id=26696626&"
import script from "./RecebimentoAdesao.vue?vue&type=script&lang=ts&"
export * from "./RecebimentoAdesao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports